module.exports = __webpack_public_path__ + "img/IMG_20190717_164232.b30492e5.jpg";